export enum ReportingOptions {
  Value = 'Value',
  Quantity = 'Quantity',
  Margin = 'Margin',
  MarginPercent = 'Margin %',
}
